import { View } from "react-native";
import React from "react";
import { useAppSelector } from "hooks/useAppSelector";
import TenantComponents from "./TenantPromotionComponents";

const TenantPromotionComponent = () => {
  const tenantSubdomain = useAppSelector(
    (state) => state.tenant.tenantSubdomain
  );

  if (!tenantSubdomain) {
    return null;
  }
  const TenantComponent = TenantComponents[tenantSubdomain];
  return <View>{TenantComponent ? <TenantComponent /> : null}</View>;
};

export default TenantPromotionComponent;
